import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
// import logo from "../assets/logo-schools.webp";
import logo from "../assets/ranridgelogo.png";
import { Link, useNavigate, NavLink } from "react-router-dom";
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate()
   const closeMenu = () =>{
    setIsOpen(false);
    window.scrollTo({top:0,behavior:"smooth"})
   } 


    const OnTop = () =>{
  
    window.scrollTo({top:0,behavior:"smooth"})
   } 
   

    const OnTopForm = () =>{
     navigate("/form")
    window.scrollTo({top:0,behavior:"smooth"})
   } 


   function homePage(){
    navigate("/")
    window.scrollTo({top:0,behavior:"smooth"})
   }


  return (
    <header className="bg-gray-50 w-full shadow-sm sticky top-0 z-50 ">
  <div className="max-w-7xl mx-0 flex justify-between items-center py-4 px-1">
    {/* Logo */}
    <div className="flex items-center justify-start p-4">
      <div onClick={()=>homePage()} className="w-auto max-w-[380px] sm:max-w-[720px] md:max-w-[450px] lg:max-w-[480px]">
        <img
          src={logo}
          alt="School Logo"
          className="w-full h-auto object-contain"
        />
      </div>
    </div>

    {/* Desktop Navigation */}
   <nav className="hidden md:flex space-x-6 text-sm font-medium">
  <NavLink
    to="/"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    Home
  </NavLink>

  <NavLink
    to="/about-us"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    About
  </NavLink>

  {/* Dropdown inline with others */}
  <div className="relative group">
    <NavLink
      to="/academics"
      onClick={OnTop}
      className={({ isActive }) =>
        isActive
          ? "text-green-900 font-semibold px-3 py-2"
          : "text-gray-800 hover:text-green-900 px-3 py-2"
      }
    >
      Academics
    </NavLink>

    {/* Dropdown items */}
    <div className="absolute hidden group-hover:block bg-white border border-gray-200 rounded-lg shadow-lg w-56 z-50">
      <NavLink
        to="/pre-primary-education"
        onClick={OnTop}
        className={({ isActive }) =>
          isActive
            ? "block px-4 py-2 bg-green-100 text-green-900 font-semibold"
            : "block px-4 py-2 text-gray-800 hover:bg-green-100 hover:text-green-900"
        }
      >
        Pre Primary
      </NavLink>
      <NavLink
        to="/primary-school-education"
        onClick={OnTop}
        className={({ isActive }) =>
          isActive
            ? "block px-4 py-2 bg-green-100 text-green-900 font-semibold"
            : "block px-4 py-2 text-gray-800 hover:bg-green-100 hover:text-green-900"
        }
      >
        Primary
      </NavLink>
      <NavLink
        to="/middle-secondary-education"
        onClick={OnTop}
        className={({ isActive }) =>
          isActive
            ? "block px-4 py-2 bg-green-100 text-green-900 font-semibold"
            : "block px-4 py-2 text-gray-800 hover:bg-green-100 hover:text-green-900"
        }
      >
        Middle to Secondary School
      </NavLink>
      <NavLink
        to="/top-iit-jee-neet-foundation"
        onClick={OnTop}
        className={({ isActive }) =>
          isActive
            ? "block px-4 py-2 bg-green-100 text-green-900 font-semibold"
            : "block px-4 py-2 text-gray-800 hover:bg-green-100 hover:text-green-900"
        }
      >
        IIT-JEE & NEET Foundation
      </NavLink>
      <NavLink
        to="/best-cbse-schools-in-hyderabad"
        onClick={OnTop}
        className={({ isActive }) =>
          isActive
            ? "block px-4 py-2 bg-green-100 text-green-900 font-semibold"
            : "block px-4 py-2 text-gray-800 hover:bg-green-100 hover:text-green-900"
        }
      >
        CBSE
      </NavLink>
      <NavLink
        to="/state-board-education"
        onClick={OnTop}
        className={({ isActive }) =>
          isActive
            ? "block px-4 py-2 bg-green-100 text-green-900 font-semibold"
            : "block px-4 py-2 text-gray-800 hover:bg-green-100 hover:text-green-900"
        }
      >
        State Board
      </NavLink>
    </div>
  </div>

  <NavLink
    to="/admissions"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    Admissions
  </NavLink>

  <NavLink
    to="/student-life"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    Student Life
  </NavLink>

  <NavLink
    to="/events"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    Events
  </NavLink>


  
  <NavLink
    to="/blog"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    Blog
  </NavLink>
</nav>

    {/* Mobile Toggle */}
    <div className="md:hidden z-50" onClick={() => setIsOpen(!isOpen)}>
      {isOpen ? (
        <FaTimes className="text-2xl text-black" />
      ) : (
        <FaBars className="text-4xl text-black" />
      )}
    </div>

    {/* Auth Buttons */}
    <div className="hidden md:flex items-center space-x-4">
      <button
        onClick={OnTopForm}
        className="bg-green-900 text-white px-4 py-2 ml-5 rounded-lg font-medium hover:bg-green-700"
      >
        Register
      </button>
    </div>
  </div>

  {/* Mobile Menu */}
  {isOpen && (
    <div className="md:hidden bg-white shadow-lg px-6 pt-4 pb-6 space-y-4 text-sm font-medium">
      <NavLink
        to="/"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Home
      </NavLink>
      <NavLink
        to="/about-us"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        About
      </NavLink>
      <NavLink
        to="/academics"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Academics
      </NavLink>

      <NavLink
        to="/pre-primary-education"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Pre Primary
      </NavLink>
      <NavLink
        to="/primary-school-education"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Primary
      </NavLink>
      <NavLink
        to="/middle-secondary-education"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Middle TO Secondary School
      </NavLink>
      <NavLink
        to="/top-iit-jee-neet-foundation"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        IIT-JEE & NEET Foundation
      </NavLink>
      <NavLink
        to="/best-cbse-schools-in-hyderabad"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        CBSE
      </NavLink>
      <NavLink
        to="/state-board-education"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        StateBoard
      </NavLink>

      <NavLink
        to="/admissions"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Admissions
      </NavLink>
      <NavLink
        to="/student-life"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Student Life
      </NavLink>
      <NavLink
        to="/events"
        onClick={closeMenu}
        className={({ isActive }) =>
          isActive ? "block text-green-900 font-semibold" : "block text-gray-800 hover:text-green-900"
        }
      >
        Events
      </NavLink>

      <NavLink
    to="/blog"
    onClick={OnTop}
    className={({ isActive }) =>
      isActive
        ? "text-green-900 font-semibold"
        : "text-gray-800 hover:text-green-900"
    }
  >
    Blog
  </NavLink>
      <hr className="my-2" />
    </div>
  )}
</header>
  );
}

export default Navbar;
